import { privateAxios } from 'services/api/privateAxios';

export const setDeliveryZone = id =>
  privateAxios({
    method: 'post',
    url: `/driver/setdeliveryzone/${Number(id)}`,
  });
